import { useRef, useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrappers,
  Label,
  SubmitBtn,
  SideCancelBtn,
  // CardWrapper,
  // SelectionCard,
  Wrapper,
  ScrollableContent,
  ActionSection,
  MobileIcon,
  ModalHeader,
} from "../Styles/InputStyles";
import tw from "tailwind-styled-components";
import { MdClose, MdEdit } from "react-icons/md";
import * as Yup from "yup";
import { tenantRelationshipOptions } from "../../Config";
import SelectOptionModal from "../SelectOptionModal";

const AddCoOccupant = ({
  addCoOccupantLoading,
  addCoOccupantMutate,
  setCoOccupantAdd,
  tenantId,
}) => {
  const [height, setHeight] = useState(window.innerHeight);
  const [showRelationshipModal, setShowRelationshipModal] = useState(false);
  let formikRef = useRef(null);

  useEffect(() => {
    if (formikRef.current) {
      formikRef.current.resetForm();
    }
    const handleResize = () => {
      setHeight(window.innerHeight); // updates when Safari UI changes
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const initialValues = {
    name: "",
    mobile: "",
    // gender: "",
    relationship: "",
  };

  // const gender = [
  //   { value: 1, label: "Male" },
  //   { value: 2, label: "Female" },
  // ];

  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Name is required")
      .matches(
        /^[A-Za-z0-9.\s]+$/,
        "Only letters, numbers, spaces and dot are allowed.",
      )
      .min(4, "Name must be at least 4 characters long"),
    mobile: Yup.string()
      .required("Mobile number is required")
      .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits"),
    // gender: Yup.number().required("Gender is required"),
    relationship: Yup.number().required("Relationship is required"),
  });

  const handleSubmit = (values, { resetForm }) => {
    addCoOccupantMutate({
      tenantId: tenantId,
      name: values.name,
      mobile: values.mobile,
      gender: 1,
      relationship: Number(values.relationship),
    });
    //resetForm();
  };

  return (
    <Container
      style={{
        height: `${height}px`,
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <ModalHeader>
        <h1 className="text-white text-lg font-medium">Add Co-Occupant</h1>
        <button onClick={() => setCoOccupantAdd(false)}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>

      <div className="px-6 h-full flex flex-col justify-between">
        <Formik
          initialValues={initialValues}
          innerRef={formikRef}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, resetForm, errors, touched }) => {
            return (
              <Form>
                <ScrollableContent className="max-h-[calc(100vh-140px)]">
                  <Wrapper>
                    <InputGroup>
                      <Label htmlFor="name">Name *</Label>
                      <FieldWrappers>
                        <Field
                          type="text"
                          name="name"
                          id="name"
                          autoComplete="off"
                          placeholder="Enter co-occupant name"
                        />
                      </FieldWrappers>
                      {errors.name && touched.name && (
                        <ErrorText>{errors.name}</ErrorText>
                      )}
                    </InputGroup>
                    <InputGroup>
                      <Label htmlFor="mobile">Mobile Number *</Label>
                      <FieldWrappers>
                        <MobileIcon />
                        <Field
                          type="text"
                          name="mobile"
                          id="mobile"
                          inputMode="numeric"
                          autoComplete="off"
                          className="pl-5"
                          placeholder="Enter 10-digit mobile number"
                          maxLength={10}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,10}$/.test(value)) {
                              setFieldValue("mobile", value);
                            }
                          }}
                        />
                      </FieldWrappers>
                      {errors.mobile && touched.mobile && (
                        <ErrorText>{errors.mobile}</ErrorText>
                      )}
                    </InputGroup>

                    {/* <InputGroup>
                      <Label>Gender *</Label>
                      <CardWrapper>
                        {gender.map((mode) => (
                          <SelectionCard
                            key={mode.value}
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              setFieldValue("gender", mode.value, true);
                            }}
                            className={
                              values.gender === mode.value
                                ? "bg-[#26A69A] text-white"
                                : "bg-gray-100 text-gray-600"
                            }
                          >
                            <span className="text-sm">{mode.label}</span>
                          </SelectionCard>
                        ))}
                      </CardWrapper>
                      {errors.gender && touched.gender && (
                        <ErrorText>{errors.gender}</ErrorText>
                      )}
                    </InputGroup> */}

                    <InputGroup>
                      <Label>Relationship *</Label>

                      <FieldWrappers
                        onClick={() => setShowRelationshipModal(true)}
                      >
                        <Field
                          type="text"
                          readOnly
                          value={
                            tenantRelationshipOptions.find(
                              (item) =>
                                item.value === Number(values.relationship),
                            )?.label || ""
                          }
                          placeholder="Relationship to tenant"
                          className="w-full bg-transparent border-none outline-none cursor-pointer"
                        />

                        <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
                      </FieldWrappers>
                      {touched.relationship && errors.relationship && (
                        <div className="min-h-[20px] mt-1">
                          <p className="text-rose-600 text-sm">
                            {errors.relationship}
                          </p>
                        </div>
                      )}
                    </InputGroup>

                  </Wrapper>
                </ScrollableContent>
                <ActionSection>
                  <SideCancelBtn
                    type="button"
                    onClick={() => {
                      setCoOccupantAdd(false);
                      resetForm();
                    }}
                  >
                    Cancel
                  </SideCancelBtn>
                  <SubmitBtn type="submit" disabled={addCoOccupantLoading}>
                    {addCoOccupantLoading ? "Submiting..." : "Submit"}
                  </SubmitBtn>
                </ActionSection>

                <SelectOptionModal
                  isOpen={showRelationshipModal}
                  onClose={() => setShowRelationshipModal(false)}
                  title="Select Relationship"
                  options={tenantRelationshipOptions}
                  selectedValue={values.relationship}
                  onSelect={(val) => {
                    setFieldValue("relationship", Number(val));
                    setShowRelationshipModal(false);
                  }}
                  searchPlaceholder="Search Relationship..."
                />
              </Form>
            );
          }}
        </Formik>
      </div>
    </Container>
  );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const ErrorText = tw.div`text-rose-600 text-sm ml-0.5`;

export default AddCoOccupant;
